<template>
  <utd-toast ref="toastRef"
             class="email-verified-toast"
             position="top-right"
             notification-mode="success"
             title="Success"
             :message="verificationMessage"
             @closed="handleClosed" />
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import PubSub from '_acaSrc/utility/PubSub';
import UtdToast from '_acaSrc/components/shared/stdlib/UtdToast.vue';
import { getQueryParamValues } from '_acaSrc/utility/http';
import { setQueryParamValueNoReload } from '_acaSrc/utility/Browsers';
import { getWindow } from '_acaSrc/utility/DOM';
import { EMAIL_VERIFIED_PARAM } from '_acaSrc/utility/constants';

const verificationMessage = computed(() =>
    'Your email has been verified. You can now access UpToDate off-network and on the mobile app.'
);

const pubsub = new PubSub();
const toastRef = ref(null);

const showToast = () => {
    const url = getWindow().location.href;
    const isVerified = getQueryParamValues(url, EMAIL_VERIFIED_PARAM);
    if (isVerified !== 'true') {
        return;
    }
    toastRef.value?.show();
};

const handleClosed = () => {
    setQueryParamValueNoReload(EMAIL_VERIFIED_PARAM);
};

onMounted(() => {
    pubsub.subscribe('showSuccessNotification', showToast);
    pubsub.subscribe('showEmailVerifiedToast', showToast);
    showToast();
});

onUnmounted(() => {
    pubsub.unsubscribe('showSuccessNotification');
    pubsub.unsubscribe('showEmailVerifiedToast');
});
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';
</style>